export const UserManagement_TABLE_TITLE = 'Client Details';
export const UserManagement_TABLE_INFO_URL = '';
